export default {
  init() {
    const $content = $(
      ".wp-block-group.is-style-team-bio .wp-block-group__inner-container"
    );

    $(".team__contact").prependTo($content);

    $(".team__contact")
      .clone()
      .addClass("team__contact--bottom")
      .appendTo($content);
  },
};
